export const en = {
    accept: 'Apply',
    back: 'Back',
    rest: 'And {count} more, continue printing'
};
